import { Controller } from "@hotwired/stimulus";

// Hides each flash message 8 seconds after it is displayed, or immediately
// when its close button is clicked.
const DISPLAY_DURATION_MS = 8000;
const FADE_DURATION_MS = 300;

export default class extends Controller {
  connect() {
    this.timers = new Map();

    Array.from(this.element.children).forEach((message) => {
      this.timers.set(
        message,
        setTimeout(() => this.hide(message), DISPLAY_DURATION_MS),
      );

      message
        .querySelector(".btn-close")
        ?.addEventListener("click", () => this.hide(message));
    });
  }

  disconnect() {
    this.timers.forEach((timer) => clearTimeout(timer));
  }

  hide(message) {
    clearTimeout(this.timers.get(message));
    this.timers.delete(message);

    message.style.transition = `opacity ${FADE_DURATION_MS}ms ease`;
    message.style.opacity = "0";
    setTimeout(() => message.remove(), FADE_DURATION_MS);
  }
}
